export function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-32 overflow-hidden">
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/d241b12dbf315630703c05509499b1c7.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900/95 via-indigo-900/90 to-gray-900/95"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <h3 className="text-6xl font-black text-white mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em' }}>
            Ready to Secure
            <br />
            Your Connection?
          </h3>
          <p className="text-xl text-blue-200 mb-10 leading-relaxed max-w-lg">
            Join thousands of users who trust BRZOGLAS VPN for their online privacy and security needs.
          </p>
          <button 
            onClick={scrollToContact}
            className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 rounded-2xl font-bold text-lg hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl cursor-pointer whitespace-nowrap group"
          >
            Get Started Now
            <div className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full group-hover:bg-gray-800 transition-colors">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
